export const ORDER = {
  ID: '주문번호',
  DISPLAY_GROSS_PRICE: '총 금액',
  DUE_DATE: '납기일',
  MEMO: '메모',
  STATUS: '주문상태',
  TOTAL_AMOUNT: '총 수량',
  CREATED_AT: '주문일시',
};

export const CUSTOMER = {
  ID: '고객번호',
  NAME: '고객사',
  MANAGER_NAME: '담당자',
  MANAGER_EMAIL: '이메일',
  MANAGER_TELNO: '연락처',
  MANAGER_ADDRESS: '주소',
};

export const ORDER_ITEM = {
  ID: '주문상품번호',
  NAME: '상품명',
  SUPPLIER_NAME: '공급사',
  UNIT_PRICE: '단가',
  QUANTITY: '수량',
};

export const SUPPLIER = {
  NAME: '공급사',
  SUPPLIER_CEO_NAME: '담당자',
  SUPPLIER_CEO_TELNO: '연락처',
  SUPPLIER_ADDRESS: '주소',
  SUPPLIER_EMAIL: '이메일',
};
